import React from 'react';
import { ThemeProvider } from '@mui/material';
import { theme } from '../theme/theme';
import '../components/ErrorReporting';
import IntakeBotPluginWidget from '../../web_chat/frontend/IntakeBotPluginWidget';
import { useFrontendConfiguration } from '../components/FrontendConfigurationProvider';
import { ErrorReportingWrapper } from '../components/ErrorReporting';
import globalTranslationManager from '../../translation/frontend/components/translation_manager';
import { AppLayoutProvider } from '@contexts/AppLayoutContext';

export default function IntakePluginApp({ token, fullscreen }) {
  const config = useFrontendConfiguration();
  if (fullscreen) {
    document.title =
      config.frontend.environment_title || config.frontend.top_bar_title;
  }
  globalTranslationManager.enabled =
    config.frontend.enable_automatic_frontend_translation;

  let app = (
    <IntakeBotPluginWidget intakeToken={token} fullscreen={fullscreen} />
  );

  app = <AppLayoutProvider>{app}</AppLayoutProvider>;

  // Wrap in Theme provider
  app = <ThemeProvider theme={theme}>{app}</ThemeProvider>;

  // Wrap in ErrorReportingWrapper
  app = <ErrorReportingWrapper>{app}</ErrorReportingWrapper>;

  return app;
}
